// extracted by mini-css-extract-plugin
export default {"buttons":"TimeOffSummaryAddRow-module__buttons___YlprZ","holidaysLink":"TimeOffSummaryAddRow-module__holidaysLink___qoXXa","empty":"TimeOffSummaryAddRow-module__empty___HhK_d"};